import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";

/**
 * Barra sticky no topo. Comunicação de nota fiscal / atendimento particular.
 * A altura reduz levemente após 120px de scroll para dar sensação de resposta.
 */
export function TopBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 120);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={[
        "sticky top-0 z-50 w-full text-white border-b-2 border-[#C9A24C]",
        "bg-gradient-to-r from-[#0F2A47] to-[#1B3A5C]",
        "transition-[height] duration-200 ease-out",
        "flex items-center justify-center",
        "h-[60px] md:h-[52px]",
        scrolled ? "h-[54px] md:h-[46px]" : "",
      ].join(" ")}
      role="note"
      style={{
        boxShadow: "inset 0 -1px 0 rgba(201,162,76,0.35)",
      }}
    >
      <div className="mx-auto flex items-center justify-center gap-2.5 px-4 py-1.5 md:py-0">
        <Receipt
          size={17}
          strokeWidth={1.5}
          className="shrink-0 text-[#C9A24C]"
          aria-hidden="true"
        />

        {/* Desktop: uma linha */}
        <p className="hidden md:block text-[14.5px] font-semibold leading-[1.35] text-center tracking-[0.005em]">
          Consulta particular a partir de R$ 600, sem convênio. Emitimos nota fiscal para reembolso.
        </p>

        {/* Mobile: duas linhas */}
        <p className="md:hidden text-center leading-[1.35]">
          <span className="block text-[13px] font-semibold tracking-[0.005em]">
            Consulta particular a partir de R$ 600
          </span>
          <span className="block text-[13px] font-normal text-white/85 tracking-[0.005em]">
            Sem convênio. Nota fiscal para reembolso.
          </span>
        </p>
      </div>
    </div>
  );
}
